import * as React from 'react';
import TableComponentV2, { KeyHeader } from '../../../shared/TableComponentV2';
import { X } from 'lucide-react';

type Props = {
    showTable: boolean
    closeTable: () => void
    data: any[]
};
const ChatChartTablePreview = ({ showTable, data, closeTable }: Props) => {
    return <div
        className="mt-6 border-t pt-4 transition-all duration-300 ease-in-out overflow-hidden"
        style={{
            opacity: showTable ? 1 : 0,
            maxHeight: showTable ? "1000px" : "0",
            transform: showTable ? "translateY(0)" : "translateY(-10px)",
            visibility: showTable ? "visible" : "hidden",
            marginTop: showTable ? "1.5rem" : 0,
            borderTopWidth: showTable ? "1px" : "0px",
            paddingTop: showTable ? "1rem" : 0,
        }}
    >
        {showTable && (
            <>
                <div className="flex justify-end">
                    <X className="h-5 w-5 cursor-pointer" onClick={closeTable} />
                </div>
                <h3 className="text-lg font-medium mb-2">Chart Data</h3>
                <TableComponentV2
                    pagination
                    count={5}
                    header={Object.keys(data[0]).map(item => {
                        return {
                            type: KeyHeader.KEY,
                            key: item,
                            label: item,
                        }
                    })}
                    items={data}
                />
            </>
        )}
    </div>
};

export default ChatChartTablePreview;